// extracted by mini-css-extract-plugin
module.exports =  {"text":"confirm_modal-module_text_c3a4c","modal":"confirm_modal-module_modal_ba78e"};